(angular => {
  "use strict";

  angular.module("EventCompany").controller("EventCompany.FormCtrl", [
    "$scope",
    "$q",
    "$mdDialog",
    "Loader",
    "Toast",
    "CompanyService",
    "EventService",
    "EventCompanyService",
    "EventHotelService",
    "model",
    FormCtrl
  ]);

  function FormCtrl($scope, $q, $mdDialog, Loader, Toast, companyService, eventService, eventCompanyService, eventHotelService, model) {
    this.model = model || {};

    const eventCompanyId = model ? model.id : '';
    const companyId = model ? model.company_id : null;
    eventService.current().then(event => {
      this.event = event;
    });

    // Degrada com graça: se uma das duas listas falhar, o modal ainda abre com a
    // outra em vez de ficar com TUDO vazio e sem salvar. Antes, um $q.all
    // rejeitado deixava `this.companies` undefined — e o $watch lá embaixo
    // quebrava o digest a cada ciclo (ver comentário abaixo).
    this.companies = [];
    this.hotels = [];

    Loader.add($q.all([
      companyService.list().catch(err => { Toast.httpHandler(err); return []; }),
      // listOptions (id+nome) e não list(): a list traz quartos+participantes de
      // cada hotel e em evento grande a resposta é cortada (ERR_HTTP2) -> o
      // combo vinha vazio e o modal abria com "Aconteceu um erro inesperado".
      eventHotelService.listOptions().catch(err => { Toast.httpHandler(err); return []; })
    ])).then(([companies, hotels]) => {
      this.companies = companies || [];
      this.hotels = hotels || [];
      this.company = this.companies.filter(c => c.id === companyId)[0];
    });

    this.save = () => {
      // O `get` só serve para o `validations()`, e este só roda quando a EMPRESA
      // foi trocada. Antes ele era chamado SEMPRE — e é um endpoint pesado:
      // eager de company.participant.activities (todos os participantes da rede,
      // com as atividades de cada um), rooms.persons e air_travel.participant.
      // Em empresa grande (FARMÁCIAS PAGUE MENOS: 180 vagas, 80 passagens) a
      // resposta era cortada com net::ERR_HTTP2_PROTOCOL_ERROR, a promise
      // rejeitava ("Possibly unhandled rejection", status -1), o `.then` nunca
      // rodava e o botão Salvar não fazia NADA — sem request de save, sem erro
      // na tela. Relato do Guilherme em 09/08.
      //
      // Editar vagas não troca a empresa, então agora esse caminho nem toca no
      // endpoint pesado. Quando a empresa É trocada, o comportamento continua
      // idêntico ao de antes (busca e valida).
      const trocouEmpresa = !!companyId && companyId !== this.model.company_id;
      const preRequisito = trocouEmpresa
        ? eventCompanyService.get(eventCompanyId)
        : $q.resolve(null);

      this.promise = preRequisito.then(eventCompany => {

        if (trocouEmpresa) {
          const validated = eventCompanyService.validations(eventCompany, this.event);
          if (validated) return;
        }

        return Loader.add(eventCompanyService.save(this.model)).then(() => {
          Toast.show("Empresa salva com sucesso", "success");
          $mdDialog.hide();
        }).catch(response => {
          const messages = {
            "less-hotel-rooms": `Quantidade de quartos menor que a utilizada: ${(response.data.data || {}).rooms} quartos`,
            "company-already-added": "Empresa já cadastrada",
            "event-spot-exceeded": "Limite do evento de vagas excedido",
            // Rede de proteção: hoje nada mais lança 'spots-exceeded' (a guarda
            // errada em services/eventCompany.save foi removida em 08/08), mas
            // se voltar, que apareça o motivo em vez de "erro inesperado".
            "spots-exceeded": "Limite do evento de vagas excedido",
            "company-spot-exceeded": `Numero de vagas menor que as vagas em uso: ${(response.data.data || {}).spots_used}`,
            "spots-used-air-travel": "Quantidade de passagens menor que a utilizada no momento",
            "spots-used-activity-premium": "Quantidade de vagas premium menor que a utilizada no momento",
            "spots-used-event-table-reservation": "Quantidade de vagas para jantar menor que a utilizada no momento"
          };

          const message = messages[response.data.message];
          if (message) {
            return Toast.show(message, "error");
          }

          // Nunca mais "Aconteceu um erro inesperado" sem pista: se o servidor
          // mandou um codigo de negocio que ainda nao esta traduzido aqui, mostra
          // o codigo. Foi assim que o 'spots-exceeded' de 08/08 virou um erro
          // mudo e ninguem conseguia alterar vaga de empresa.
          if (response.data && typeof response.data.message === "string") {
            return Toast.show(`Nao foi possivel salvar (${response.data.message})`, "error");
          }

          Toast.httpHandler(response);
        });
      });
    };

    this.cancel = $mdDialog.cancel;

    // ERA UM LOOP INFINITO (corrigido 2026-08-08). A forma antiga passava pro
    // $watch uma funcao COM EFEITO COLATERAL e sem valor de retorno: a cada
    // digest ela agendava um $timeout; cada $timeout dispara outro digest, que
    // agenda outro $timeout... Alem disso lia `this.companies.filter` quando a
    // lista ainda era undefined (ou tinha falhado de carregar) e estourava
    // "Cannot read properties of undefined (reading 'filter')" a cada volta —
    // 2.5 mil erros no console, digest quebrado, modal abrindo com os campos
    // vazios e o Salvar sem efeito (relato da Luana em 08/08).
    // Agora e um watch de VALOR: so roda quando company_id muda de verdade.
    $scope.$watch(
      () => this.model.company_id,
      companyIdSelecionado => {
        this.company = (this.companies || []).filter(c => c.id === companyIdSelecionado)[0];
      }
    );

  }
})(angular || {});
